import React, { Component } from 'react';

class About extends Component {
  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var profilepic= "images/"+this.props.data.image;
      var bio = this.props.data.bio;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var resumeLink = this.props.data.resumeLink;
      var transcriptLink = this.props.data.transcriptLink;
    }

    return (
      <section id="about">
      <div className="row">
         <div className="three columns">
            <img className="profile-pic"  src={profilepic} alt="Ryan Grayson Profile Pic" style={{width: '140%', height: '154%'}}/>
         </div>
         <div className="nine columns main-col">
            <h2>About Me</h2>

            <p>{bio}</p>
            <div className="row">
               <div className="columns contact-details">
                  <h2>Contact Details</h2>
						   <span>{name}</span><br />
						   <span>{phone}</span><br />
                     <span>{email}</span>
               </div>
               <div className="columns download">
                  <p>
                     <a href={resumeLink} className="button" target="_blank"><i className="fa fa-external-link-square"></i>Resume</a><br></br>
                     <a href={transcriptLink} className="button" target="_blank"><i className="fa fa-external-link-square"></i>Transcript</a>
                  </p>
               </div>
            </div>
         </div>
      </div>

   </section>
    );
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/Components/About.js